import React from "react";
import { DropdownSingle, icons, colors2, UI_BODY_SEMIBOLD_SM_DF } from "oolib";
import { colors } from "oolib/dist/v2/themes";

const { CaretDown } = icons;

export function PillDropdown({ value, onChange, options, ...rest }) {
  return (
    <DropdownSingle
      value={value}
      onChange={onChange}
      options={options}
      genCustomSelectComp={() => (
        <UI_BODY_SEMIBOLD_SM_DF style={{ borderBottom: `1px solid ${colors.grey40}`, cursor: "pointer" }}>
          {value?.display} <CaretDown size={7} color={colors2.grey60} weight="bold" />
        </UI_BODY_SEMIBOLD_SM_DF>
      )}
      {...rest}
    />
  );
}
